<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-tabs slider-color="grey">
        <v-tab class="tab" v-if="globalModalParams.type != 'orig_region' && globalModalParams.type != 'customer_region'" :key="1" ripple>Details</v-tab>
        <v-tab class="tab" :key="2" v-if="globalModalParams.type != 'customer' && globalModalParams.type != 'orig_region' && globalModalParams.type != 'customer_region'" ripple>Limits</v-tab>
        <v-tab class="tab" :key="3" v-if="globalModalParams.type != 'customer' && globalModalParams.type != 'orig_region' && globalModalParams.type != 'customer_region'" ripple>Pricelists</v-tab>
        <v-tab class="tab" :key="4" ripple>Regions</v-tab>
        <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="1" v-if="globalModalParams.type != 'orig_region' && globalModalParams.type != 'customer_region'">
          <v-container grid-list-xl>
            <v-layout row wrap>
              <v-flex xs4><strong>Full Name:</strong><br />{{ objUserInfo.name }} {{ objUserInfo.surname }}</v-flex>
              <v-flex xs4><strong>Role:</strong><br />{{ objUserInfo.role }}</v-flex>
              <v-flex xs4 v-if="objUserInfo.contactno == ''"><strong>Contact No:</strong><br />N/A</v-flex>
              <v-flex xs4 v-else><strong>Contact No:</strong><br />{{ objUserInfo.contactno }}</v-flex>
              <v-flex xs4 v-if="objUserInfo.alt_contactno == ''"><strong>Alternative No:</strong><br />N/A</v-flex>
              <v-flex xs4 v-else><strong>Alternative No:</strong><br />{{ objUserInfo.alt_contactno }}</v-flex>
              <v-flex xs4><strong>Email Address:</strong><br />{{ objUserInfo.email }}</v-flex>
              <v-flex xs4 v-if="objUserInfo.vat_no == ''"><strong>VAT No:</strong><br />N/A</v-flex>
              <v-flex xs4 v-else><strong>VAT No:</strong><br />{{ objUserInfo.vat_no }}</v-flex>
              <v-flex xs4><strong>Physical Address:</strong><br />{{ objUserInfo.address }}</v-flex>
              <v-flex xs4><strong>Preferred Follow Up:</strong><br />{{ objUserInfo.pmoc }}</v-flex>
              <v-flex xs4><strong>Active for MyOrder:</strong><br />{{ objUserInfo.active }}</v-flex>
              <v-flex xs4><strong>User Type:</strong><br />{{ fncReturnUserType(objUserInfo.type) }}</v-flex>
              <v-flex xs4><strong>Created On:</strong><br />{{ objUserInfo.created }}</v-flex>
              <v-flex xs4><strong>Last modified:</strong><br />{{ objUserInfo.modified }}</v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2" v-if="globalModalParams.type != 'customer' && globalModalParams.type != 'orig_region' && globalModalParams.type != 'customer_region'">
          <v-container grid-list-xl>
            <v-layout row wrap>
              <v-flex xs4><strong>Maximum Discounts:</strong><br />{{ objUserInfo.discount_max }}%</v-flex>
              <v-flex xs4><strong>Default Discounts:</strong><br />{{ objUserInfo.discount_def }}%</v-flex>
              <v-flex xs4><strong>Maximum Incidental Value:</strong><br />{{ objUserInfo.inc_max }}%</v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="3" v-if="globalModalParams.type != 'customer' && globalModalParams.type != 'orig_region' && globalModalParams.type != 'customer_region'">
          <v-container grid-list-xl>
            <v-data-table :headers="plistHeaders" :items="objUserInfo.pricelist_names" expand class="elevation-1 minTable" hide-actions :rows-per-page-items="[10000000]">
              <template slot="items" slot-scope="props">
                <tr>
                  <td width="100%" class="text-xs-right">{{ props.item }}<i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_upward</i></td>
                </tr>
              </template>
            </v-data-table>
          </v-container>
        </v-tab-item>
        <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="4">
          <v-container grid-list-xl>
<div class="popupTable" style="width:100%; overflow-y: auto">
  <v-data-table :headers="regionHeaders" :items="objUserInfo.allRegions" expand class="elevation-1 mainTable" hide-actions :rows-per-page-items="[10,20,40,60,80,100]">
    <template slot="items" slot-scope="props">
      <tr>
        <td v-if="props.expanded == true" width="100%" @click="props.expanded = !props.expanded" class="text-xs-right">{{ props.item.NAME }} <i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_upward</i></td>
        <td v-else width="100%" @click="props.expanded = !props.expanded" class="text-xs-right">{{ props.item.NAME }} <i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_downward</i></td>
      </tr>
    </template>
    <template slot="expand" slot-scope="props">
      <v-data-table :search="search" :headers="regionHeaders" :items="props.item.children" expand class="elevation-1 subTable subTable1 minTable" hide-actions :rows-per-page-items="[10000000]">
        <template slot="items" slot-scope="props">
          <tr>
            <td v-if="props.expanded == true" width="100%" @click="props.expanded = !props.expanded" class="text-xs-right">{{ props.item.NAME }} <i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_upward</i></td>
            <td v-else width="100%" @click="props.expanded = !props.expanded" class="text-xs-right">{{ props.item.NAME }} <i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_downward</i></td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <v-data-table :search="search" :headers="regionHeaders" :items="props.item.children" expand class="elevation-1 subTable2 minTable" hide-actions :rows-per-page-items="[10000000]">
            <template slot="items" slot-scope="props">
              <tr>
                <td v-if="props.expanded == true" width="100%" @click="props.expanded = !props.expanded" class="text-xs-right">{{ props.item.NAME }} <i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_upward</i></td>
                <td v-else width="100%" @click="props.expanded = !props.expanded" class="text-xs-right">{{ props.item.NAME }} <i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_downward</i></td>
              </tr>
            </template>
          </v-data-table>
        </template>
        <template slot="expand" slot-scope="props">
          <v-data-table :search="search" :headers="regionHeaders" :items="props.item.children" expand class="elevation-1 subTable2 minTable" hide-actions :rows-per-page-items="[10000000]">
            <template slot="items" slot-scope="props">
              <tr>
                <td v-if="props.expanded == true" width="100%" @click="props.expanded = !props.expanded" class="text-xs-right">{{ props.item.NAME }} <i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_upward</i></td>
                <td v-else width="100%" @click="props.expanded = !props.expanded" class="text-xs-right">{{ props.item.NAME }} <i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_downward</i></td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-data-table :search="search" :headers="regionHeaders" :items="props.item.children" expand class="elevation-1 subTable3 minTable" hide-actions :rows-per-page-items="[10000000]">
                <template slot="items" slot-scope="props">
                  <tr>
                    <td v-if="props.expanded == true" width="100%" @click="props.expanded = !props.expanded" class="text-xs-right">{{ props.item.NAME }} <i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_upward</i></td>
                    <td v-else width="100%" @click="props.expanded = !props.expanded" class="text-xs-right">{{ props.item.NAME }} <i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_downward</i></td>
                  </tr>
                </template>
              </v-data-table>
            </template>
          </v-data-table>
        </template>
      </v-data-table>
    </template>
   </v-data-table>


  </v-data-table>
  </div>
        </v-container
  >


        </v-tab-item>
      </v-tabs>
      <div class="pl-4 pr-4 pb-4 buttonHolder">
        <div style="float: right">
          <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
        </div>
      </div>
      <v-flex lg12 class="requiredMessage">
        <small><strong>&nbsp;</strong></small>
      </v-flex>
    </v-layout>
  </v-container>
	<!--<v-container grid-list-lg>
		<v-layout row wrap>
			<v-flex lg12 class="userInfo">
				<div class="section">
					<h2>User Details</h2>
					<table width="100%">
						<tr>
							<td width="25%"><strong>Full Name:</strong></td>
							<td>{{ objUserInfo.name }} {{ objUserInfo.surname }}</td>
						</tr>
						<tr>
							<td width="25%"><strong>Role:</strong></td>
							<td>{{ objUserInfo.role }}</td>
						</tr>
					</table>
				</div>
				<div class="section">
					<h2>Contact Info</h2>
					<table width="100%">
						<tr>
							<td width="25%"><strong>Contact No:</strong></td>
							<td>{{ objUserInfo.contactno }}</strong></td>
						</tr>
						<tr>
							<td width="25%"><strong>Alternative No:</strong></td>
							<td>{{ objUserInfo.alt_contactno }}</td>
						</tr>
						<tr>
							<td width="25%"><strong>Email Address:</strong></td>
							<td>{{ objUserInfo.email }}</td>
						</tr>
						<tr>
							<td width="25%"><strong>Vat No:</strong></td>
							<td>{{ objUserInfo.vat_no }}</td>
						</tr>
						<tr>
							<td width="25%"><strong>Physical Address:</strong></td>
							<td>{{ objUserInfo.address }}</td>
						</tr>
						<tr>
							<td width="25%"><strong>Preferred Follow Up:</strong></td>
							<td>{{ objUserInfo.pmoc }}</td>
						</tr>
					</table>
				</div>
				<div class="section">
					<h2>User Limits</h2>
					<table width="100%">
						<tr>
							<td width="25%"><strong>Maximum Discounts:</strong></td>
							<td>{{ objUserInfo.discount_max }}%</td>
						</tr>
						<tr>
							<td width="25%"><strong>Default Discounts:</strong></td>
							<td>{{ objUserInfo.discount_def }}%</td>
						</tr>
						<tr>
							<td width="25%"><strong>Maximum Incidental Value:</strong></td>
							<td>{{ objUserInfo.inc_max }}</td>
						</tr>
					</table>
				</div>
				<div class="section">
					<h2>User Info</h2>
					<table width="100%">
						<tr>
							<td width="25%"><strong>Active for MyOrder:</strong></td>
							<td>{{ objUserInfo.active }}</td>
						</tr>
						<tr>
							<td width="25%"><strong>User Type:</strong></td>
							<td>{{ userTypes[objUserInfo.type] }}</td>
						</tr>
						<tr>
							<td width="25%"><strong>Created On:</strong></td>
							<td>{{ objUserInfo.created }}</td>
						</tr>
						<tr>
							<td width="25%"><strong>Last Modified:</strong></td>
							<td>{{ objUserInfo.modified }}</td>
						</tr>
						<tr>
							<td width="25%" valign="top"><strong>User Regions:</strong></td>
							<td v-html="fncSplitObject( objUserInfo.user_locations )"></td>
						</tr>
						<tr>
							<td width="25%" valign="top"><strong>User Pricelists:</strong></td>
							<td v-html="fncSplitObject( objUserInfo.pricelist_names )"></td>
						</tr>
					</table>
				</div>
			</v-flex>
			<div class="pl-4 pr-2 pb-4 buttonHolder">
				<div style="float: right">
					<v-btn color="success" class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
				</div>
			</div>
		</v-layout>
	</v-container>-->
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
	  name: 'Settings',
	  data () {
			return {
				objUser: 0,
				userTypes: {
				    1: 'Manufacturer',
					2: 'Customer',
					3: 'Specific',
					4: 'Public'
				},
                userRegions: '',
                plistHeaders: [
                  { text: 'Name', value: 'name', width: '100%' }
                ],
                regionHeaders: [
                  { text: 'Name', value: 'name', width: '100%' }
                ]
			};
		},
      methods: {
        fncReturnUserType(userType) {
          if (userType == 1) {
            return this.objAuthorize.manu_user_alias;
          } else if (userType == 4) {
            return this.objAuthorize.public_user_alias;
          } else {
            return this.objAuthorize.customer_user_alias;
          }
        },
			fncHideModal () {
				this.$store.commit('hideModal');
			},
            fncSplitObject( splitObj ) {
			    var toReturn = '';
                for (var key in splitObj) {
                    toReturn += splitObj[key] + "<br />";
                }
                return toReturn.substring(0, toReturn.length - 1);
			},
            fncGetUserPricelists( pricelistObj ) {
			    this.$store.dispatch({
					type: 'fncGetUserPricelists',
					pricelists: pricelistObj
				});
			}
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'objUserInfo',
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
